import styled, { FlattenSimpleInterpolation, css } from 'styled-components';
import { Body1, colors, H4, spacing } from 'ui/theme';
import { EMPTY_STATE_VARIANTS } from './EmptyState.types';

export const VARIANT_STYLES: {
  [variant in EMPTY_STATE_VARIANTS]: FlattenSimpleInterpolation;
} = {
  [EMPTY_STATE_VARIANTS.DEFAULT]: css``,
  [EMPTY_STATE_VARIANTS.ILLUSTRATION_TWO_COL]: css``,
  [EMPTY_STATE_VARIANTS.WITH_BORDERED_CONTAINER]: css`
    border: solid ${spacing.single} ${colors.grey15};
    border-radius: ${spacing.half};
    padding: ${spacing.double};
  `,
};

export const Wrapper = styled.div<{ variant: EMPTY_STATE_VARIANTS }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  ${({ variant }) => VARIANT_STYLES[variant] || ``};
`;

export const TwoColumnWrapper = styled.div`
  border: solid ${spacing.single} ${colors.grey15};
  border-radius: ${spacing.half};
  padding: ${spacing.double};
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${spacing.half};
`;

export const TwoColumnTitle = styled(H4)`
  margin: ${spacing.half} 0;
  text-align: left;
`;

export const TwoColumnSubtitle = styled(Body1)`
  color: ${colors.secondaryText};
  margin: 0;
  text-align: left;
  white-space: normal;
`;

export const Title = styled(H4)`
  margin: ${spacing.half} 0;
  text-align: center;
`;

export const Subtitle = styled(Body1)`
  color: ${colors.secondaryText};
  margin: 0;
  text-align: center;
  white-space: normal;
`;
